import { DATA_SCOPES, FILTER_TYPE } from "../filterConstants"
import { NumberFilter } from "../filterTypes/numberFilter"
import { StringFilter } from "../filterTypes/stringFilter"

export class UserIdFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super("User ID", FILTER_TYPE.USER.ID, [DATA_SCOPES.USERS], null, visibility, restrictedToScope)
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, user) {
    return user.user_id
  }
}

export class UserEmailFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super("Email", FILTER_TYPE.USER.EMAIL, [DATA_SCOPES.USERS], null, visibility, restrictedToScope)
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, user) {
    return user.email
  }
}

export class UserNameFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Username",
      FILTER_TYPE.USER.USERNAME,
      [DATA_SCOPES.USERS],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, user) {
    return user.username
  }
}

export class FirstNameFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "First Name",
      FILTER_TYPE.USER.FIRST_NAME,
      [DATA_SCOPES.USERS],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, user) {
    return user.first_name
  }
}

export class LastNameFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Last Name",
      FILTER_TYPE.USER.LAST_NAME,
      [DATA_SCOPES.USERS],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, user) {
    return user.last_name
  }
}

export class UserPhoneFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Phone Number",
      FILTER_TYPE.USER.PHONE_NUMBER,
      [DATA_SCOPES.USERS],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, user) {
    return user.phone_number
  }
}
